module.exports = __webpack_public_path__ + "static/1.1.E.2 FORNA RANDARE 2-11f0b963f074bb39ae00d1e7ed2de811.jpg";